const ARCHIVOS = {
  grilla: 'grilla.json',
  amenities: 'amenities.json',
  ttm: 'ttm.json',
};

async function cargarArchivo(nombre) {
  const url = `${process.env.PUBLIC_URL}/datos/${nombre}`;
  const respuesta = await fetch(url);
  if (!respuesta.ok) {
    throw new Error(
      `No se pudo cargar ${nombre} (${respuesta.status} ${respuesta.statusText})`
    );
  }
  return respuesta.json();
}

// casa_trabajo.json (segundo orden) e isocronas.json (isocronas reales) son
// dependencias opcionales: la primera solo existe si se corrio el modelo de
// asignacion con microdatos censales externos, la segunda si se corrio
// preparar_ttm_hex.py con r5py. Sin ellas la app funciona igual: sin la capa
// de destinos de trabajo, o con la cascada topologica en vez del pulso real.
async function cargarOpcional(nombre, etiqueta) {
  try {
    return await cargarArchivo(nombre);
  } catch (error) {
    console.warn(`${nombre} no disponible, sin ${etiqueta}:`, error.message);
    return {};
  }
}

// Los tres archivos base bastan para pintar la grilla e interactuar; son la
// mitad del peso total. Los opcionales (10 MB) llegan despues sin bloquear el
// primer render: mientras tanto la app opera en su modo degradado normal.
export async function cargarDatosBase() {
  const [grilla, amenities, ttm] = await Promise.all(
    Object.values(ARCHIVOS).map(cargarArchivo)
  );
  return { grilla, amenities, ttm, casaTrabajo: {}, isocronas: {} };
}

export async function cargarDatosOpcionales() {
  const [casaTrabajo, isocronas] = await Promise.all([
    cargarOpcional('casa_trabajo.json', 'la capa de segundo orden'),
    cargarOpcional('isocronas.json', 'las isocronas reales (queda la cascada topologica)'),
  ]);
  return { casaTrabajo, isocronas };
}
